import React, { useMemo } from 'react'
import { Checkbox, Divider, Input, Row, Typography } from 'antd'
import { isEmpty, join, map } from 'lodash'

import { GridFormItem, LinkButton } from '../../../core/components/sections'

import {
  ReadMore,
  TypographyLinkWrapper,
} from '../../../common/components/sections'
import { StyledFlexInputGroup } from '../../../common/components/styled'
import { APP_ROUTES, EXCLUSION_STATUS } from '../../../common/constants'

import { menuCurationTaskPropType } from '../../prop-types'

import MenuDocumentDownloadButton from './menu-document-download-button'

const MenuCurationTaskHeader = ({ menuCurationTask }) => {
  const scrapingValidationMessagesComponent = useMemo(() => {
    if (isEmpty(menuCurationTask.menu?.scrapingValidationMessages)) {
      return null
    }

    return (
      <>
        {map(
          menuCurationTask.menu.scrapingValidationMessages,
          (message, index) => (
            <Typography.Text
              key={index}
              type="secondary"
              style={{ display: 'block', marginBottom: 4 }}
            >
              {message}
            </Typography.Text>
          ),
        )}
      </>
    )
  }, [menuCurationTask.menu.scrapingValidationMessages])

  return (
    <>
      <Row gutter={16}>
        <GridFormItem span={2} label="Brand Curation Task Id">
          <TypographyLinkWrapper
            to={`${APP_ROUTES.BRANDS.children.BRAND_DETAILS.fullPath}/${menuCurationTask.brandCurationTaskId}`}
            target="_blank"
          >
            {menuCurationTask.brandCurationTaskId}
          </TypographyLinkWrapper>
        </GridFormItem>
        <GridFormItem span={2} label="Menu Id">
          <Typography.Text strong>{menuCurationTask?.menu?.id}</Typography.Text>
        </GridFormItem>
        <GridFormItem span={2} label="Autoeat Id">
          <Typography.Text strong>
            {menuCurationTask?.menu?.autoeatId}
          </Typography.Text>
        </GridFormItem>
        <GridFormItem span={2} label="AutoEat status">
          <Typography.Text strong>
            {EXCLUSION_STATUS[menuCurationTask?.menu?.status]?.label}
          </Typography.Text>
        </GridFormItem>
        <GridFormItem span={3} label="Brand">
          <Typography.Text strong>
            {menuCurationTask?.menu?.brand?.name}
          </Typography.Text>
        </GridFormItem>
        <GridFormItem span={2} label="Published">
          <Typography.Text strong>
            <Checkbox checked={menuCurationTask?.menu?.isPublished} disabled />
          </Typography.Text>
        </GridFormItem>
        <GridFormItem span={3} label="Cuisine Type">
          <Typography.Text strong>
            {menuCurationTask?.menu?.brand?.cuisineType?.name}
          </Typography.Text>
        </GridFormItem>
        <GridFormItem span={3} label="Main Location Type">
          <Typography.Text strong>
            {menuCurationTask?.menu?.brand?.mainLocationType?.name}
          </Typography.Text>
        </GridFormItem>
        <GridFormItem span={3} label="Additional Location Type">
          <Typography.Text strong>
            {!isEmpty(menuCurationTask?.menu?.brand?.additionalLocationTypes)
              ? join(
                  map(
                    menuCurationTask?.menu?.brand?.additionalLocationTypes,
                    'name',
                  ),
                  ', ',
                )
              : '-'}
          </Typography.Text>
        </GridFormItem>
        <GridFormItem span={2} label="Locations">
          {menuCurationTask?.menu?.locationCount}
        </GridFormItem>
      </Row>
      <Divider />
      <Row gutter={16}>
        <GridFormItem span={6} label="Website">
          <StyledFlexInputGroup compact>
            <Input readOnly disabled value={menuCurationTask?.menu?.url} />
            <LinkButton link={menuCurationTask?.menu?.url} shape="square" />
          </StyledFlexInputGroup>
        </GridFormItem>
        <GridFormItem span={3} label="Menu Type">
          <StyledFlexInputGroup compact>
            <Typography.Text strong>
              {menuCurationTask?.menu?.scrapingType}
            </Typography.Text>
          </StyledFlexInputGroup>
        </GridFormItem>
        {menuCurationTask?.menu?.fileKey && (
          <GridFormItem span={5} label="Menu Document">
            <MenuDocumentDownloadButton menuCurationTask={menuCurationTask} />
          </GridFormItem>
        )}
        {scrapingValidationMessagesComponent && (
          <GridFormItem span={10} label="Scraping Validation Messages">
            <ReadMore
              maxHeight={65}
              component={scrapingValidationMessagesComponent}
            />
          </GridFormItem>
        )}
      </Row>
      <Divider />
    </>
  )
}

MenuCurationTaskHeader.propTypes = {
  menuCurationTask: menuCurationTaskPropType.isRequired,
}

export default MenuCurationTaskHeader
